module.exports = __webpack_public_path__ + "img/inter-3.d7f77a60.jpg";